import { Chip, useTheme, useMediaQuery, Box } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import RootStore from '../stores/RootStore'

export default function DevDisplay() {
  const store = useContext(RootStore)
  const isDev = store.config.name === 'development'

  if (!isDev) return null

  return <Box sx={{ position: 'fixed', bottom: 0, right: 0, p: 1 }}>
    <BreakPointLabel />
  </Box>
}

function BreakPointLabel() {
  const theme = useTheme()
  const [tooBig, setTooBig] = useState(false)

  const isXs = useMediaQuery(theme.breakpoints.only('xs'))
  const isSm = useMediaQuery(theme.breakpoints.only('sm'))
  const isMd = useMediaQuery(theme.breakpoints.only('md'))
  const isLg = useMediaQuery(theme.breakpoints.only('lg'))
  const isXl = useMediaQuery(theme.breakpoints.only('xl'))

  const getBreakpoint = () => {
    if (isXs) return 'xs'
    if (isSm) return 'sm'
    if (isMd) return 'md'
    if (isLg) return 'lg'
    if (isXl) return 'xl'
    return ''
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      setTooBig(window.innerWidth > 1200 || window.innerHeight > 800)
    })
  }, [])

  return (
    <Chip
      label={getBreakpoint().toUpperCase()}
      size='small'
      color={tooBig ? 'error' : 'default'}
    />
  )
}

